import { Options } from '../components/product-options';
import { getUrlParams } from '../helpers/handle-url';
import ConfiButton from '../components/confi-button';
import ShareLinks from '../components/share-links';
import { Tooltip } from '../components/Tooltip';
import PriceCalculator from '../components/price-calculator';
import ImageUpdater from '../components/views/product-image-updater';
import Flyout from '../components/dropdown-flyout';
import Popup from '../components/popups/popup';
import BuySamplePopup from '../components/popups/buy-sample-popup';
import TestProductPopup from '../components/popups/test-product-popup';
import ZoomGalleryPopup from '../components/popups/zoom-gallery-popup';
import MoreDetailsPopup from '../components/popups/more-details-popup';
import HeaderFeatures from '../components/header-features';
import UpdateUserAccount from '../components/update-user-account';
import OpenClose from '../components/open-close';
import Cookies from '../components/cookie';
import CustomSelect from '../components/custom-select';
import Common from '../components/common';
import TeaserTiles from '../components/teaser-tiles';
import Gallery from '../components/gallery';
import ProductImagesSlider from '../components/ProductImagesSlider';
import { DeviceManager } from '../components/DeviceManager';
import VideoEmbed from '../components/video-embed';
import { BannerController } from '../components/BannerController';
import { MessagePopup } from '../components/messagePopup';
import PageTypes from '../helpers/page-types';
import Tracker from '../helpers/tracker';
import { HotfoilEffectBuilder } from '../builders/HotfoilEffectBuilder';
import { Scroller } from '../components/galleries/scroller';
import { LoadingIndicator } from '../components/mixins/loading-indicator';
import { assetsUrlReplace } from '../helpers/assets-image-url-rewriter';
import { EnhanceEcommerce } from '../helpers/EnhanceEcommerce';
import { WishListComponent } from '../components/WishList';
import { DownloadAppModalEvents, WishListEvents } from '../Modules/Types';
import { TrackingData } from '../helpers/TrackingTypes';
import { RealDoorComponent } from '../components/RealDoorComponent';
import { initBanners } from '../components/banners/index';
import { GA4SocialNetworkTracker } from '../components/GA4/GA4SocialNetworkTracker';
import { ShippingDateService } from '../components/ShippingDateService';
import { getHTMLElement } from '../helpers/dom-interact';
import { ApiEndpoints } from '../Configurations/ApiEndpoints';

function instantiateScrollers() {
	const scrollers = document.querySelectorAll('.js-products-scroller');

	for (let i = 0; i < scrollers.length; i++) {
		new Scroller(scrollers[i], {
			classes: {
				viewport: '.js-viewport',
				slide: '.js-slide',
				prevButton: '.js-prev-button',
				nextButton: '.js-next-button',
			},
			buttonState: 'is-disabled',
			trackingCategory: TrackingData.PAGE_PDP,
		});
	}
}

function getShoppingSku() {
	const customOptions = getUrlParams();

	let format = customOptions.format || productJSON.preConfig.format;

	let color = customOptions.color || productJSON.preConfig.color;

	format = format ? `-${format}` : '';
	color = color ? `-${color}` : '';

	return { shoppingSku: `${productJSON.abstractSku}${format}${color}` };
}

function hasCover(hardcoverProducts, softcoverProducts) {
	return hardcoverProducts.length > 0 && softcoverProducts.length > 0;
}

const PDP = function () {
	initBanners('PDP');

	const softcoverProducts = productJSON.concreteProducts.filter((product) => {
		return (
			product.productOptions.cover &&
			product.productOptions.cover.some((coverType) => {
				return coverType.key === 'softcover';
			})
		);
	});

	const hardcoverProducts = productJSON.concreteProducts.filter((product) => {
		return (
			product.productOptions.cover &&
			product.productOptions.cover.some((coverType) => {
				return coverType.key === 'hardcover';
			})
		);
	});

	const urlParams = getUrlParams();
	const format = urlParams.format || productJSON.preConfig.format;

	if (hasCover(hardcoverProducts, softcoverProducts)) {
		const coverSelect = document.querySelector('.js-option-cover');
		switchCover(coverSelect.getAttribute('data-option'), format);
	}

	function switchCover(coverType, format) {
		if (coverType === 'hardcover') {
			switchFormats(
				hardcoverProducts.map((product) => {
					return product.format;
				}),
				format
			);
		}
		if (coverType === 'softcover') {
			switchFormats(
				softcoverProducts.map((product) => {
					return product.format;
				}),
				format
			);
		}
	}

	function switchFormats(newFormats, formatToSwitchTo) {
		const formatOptionsToSwitchTo = Array.from(
			document.querySelector('[data-backend-filter="option-list-format"]').children
		).filter((option) => {
			return newFormats.includes(option.getAttribute('data-format'));
		});
		formatOptionsToSwitchTo.forEach((option) => {
			option.style.display = 'list-item';
		});

		const newSelectedFormatOption = formatToSwitchTo
			? formatOptionsToSwitchTo.find((option) => option.getAttribute('data-format') === formatToSwitchTo)
			: formatOptionsToSwitchTo[0];

		setTimeout(() => {
			newSelectedFormatOption.click();
		}, 0);

		Array.from(document.querySelector('[data-backend-filter="option-list-format"]').children)
			.filter((option) => {
				return !newFormats.includes(option.getAttribute('data-format'));
			})
			.forEach((option) => {
				option.style.display = 'none';
			});
	}

	const hasTestProductOnPage = document.querySelector('[class*="js-test-product"]');
	const loadingIndicator = new LoadingIndicator();
	const messagePopup = new MessagePopup(document.querySelector('.js-message-popup'));

	new Common({
		trackingCategory: TrackingData.PAGE_PDP,
	}); // Common should be first because it contains error-logger

	const mainElements = document.querySelectorAll('.item-details-wrapper');
	const scope = jQuery(mainElements);
	const productSliderScope = jQuery('.js-products-scroller').not('.js-products-scroller-static');
	const freeSampleInfoHolderList = scope.find('.js-free-sample-info');
	const tooltipList = [];
	const cookies = new Cookies();

	_.each(freeSampleInfoHolderList, (holder) => {
		const tooltipInstance = new Tooltip(holder);

		tooltipList.push(tooltipInstance);
	});
	const priceCalculator = new PriceCalculator({
		tooltipList,
		openTooltipOnPriceChange: true,
		totalHolder: scope.find('.js-total-price'),
		priceHolder: scope.find('span.price-per-item'),
		data: productJSON,
		quantity: getUrlParams().quantity || false,
	});

	const confiButton = new ConfiButton({
		el: scope.find('.js-personalize-button'),
		mode: PageTypes.PDP,
		data: productJSON,
		overlay: '.js-ajax-overlay',
		cookies: cookies,
	});

	const configuratorRealDoorButtons = jQuery('.js-personalize-button.js-real-door-popup');
	// cookie name updated from "downloadAppModalShown" to "downloadAppModalShown_1" to reset for new Posters products
	if (configuratorRealDoorButtons.length && !cookies.checkIfCookieSet('downloadAppModalShown_1')) {
		const realDoorComponent = new RealDoorComponent({
			configuratorButtons: configuratorRealDoorButtons,
			cookies,
			productGroup: productJSON.groupIdentifier,
		});

		realDoorComponent.addEventListener(DownloadAppModalEvents.POPUP_OPEN, (event, settings) => {
			messagePopup.openPopup(settings);
			const element = jQuery('.js-message-popup .js-go-to-configurator-btn');
			confiButton.addButton(element);
		});
		realDoorComponent.addEventListener(DownloadAppModalEvents.POPUP_CLOSE, (event, settings) => {
			Tracker.track({
				category: TrackingData.PAGE_PDP,
				action: settings.trackingAction,
			});
			messagePopup.closePopup();
		});
	}

	const wishListComponents = new WishListComponent({
		trackingCategory: TrackingData.PAGE_PDP,
	});

	wishListComponents.addEventListener(WishListEvents.REQUEST_START, () => loadingIndicator.showLoader());
	wishListComponents.addEventListener(WishListEvents.REQUEST_END, () => loadingIndicator.hideLoader());
	wishListComponents.addEventListener(WishListEvents.POPUP_OPEN, (event, settings) =>
		messagePopup.openPopup(settings)
	);
	wishListComponents.addEventListener(WishListEvents.POPUP_CLOSE, () => messagePopup.closePopup());
	wishListComponents.addEventListener(WishListEvents.POPUP_DISABLE, () => messagePopup.disableInnerElements());

	const wishListButton = wishListComponents.getWishListButton({
		elementsList: mainElements.item(0).querySelectorAll('.js-add-wishlist'),
		data: productJSON,
	});

	let hotfoil = HotfoilEffectBuilder.getHotfoil(productJSON.preConfig.refinement);
	const hotfoilBuilder = new HotfoilEffectBuilder(hotfoil);

	const mobileImages = Array.from(document.querySelectorAll('.js-mobile-image')).map((img) =>
		hotfoilBuilder.build(img)
	);
	const desktopImages = Array.from(document.querySelectorAll('.js-product-img')).map((img) =>
		hotfoilBuilder.build(img)
	);

	const options = new Options({
		json: productJSON,
		opts: {
			el: scope,
			control: '.option',
			event: 'click',
			mode: PageTypes.PDP,
			actionElement: '.colors-list,.custom-select-holder',
			activeClass: 'selected',
			detailsHolder: scope.find('.card-details'),
			crossSellingsHolder: scope.find('.cross-selling-products > ul').eq(0),
			confiButton,
			wishlistButton: wishListButton,
			priceCalculator,
			imageUpdater: new ImageUpdater({
				mainImg: scope.find('.main-image .product-img, .main-image source'),
				galleryImg: scope.find('.main-image .slider-tiles img'),
				crossSellingImg: scope.find('.cross-selling-products .product-img'),
				sliderImg: productSliderScope.find('.js-scroller .product-img'),
				data: {
					noColors: !productJSON.possibleOptions.color,
					paper: productJSON.preConfig.paper,
					outer_paper: productJSON.preConfig.outerPaper,
				},
			}),
			shipmentTime: new ShippingDateService(
				['local', 'stage'].some((condition) => location.href.includes(condition))
					? ApiEndpoints.STAGE_SHIPPING_DATE_SERVICE
					: ApiEndpoints.PRODUCTION_SHIPPING_DATE_SERVICE,
				getHTMLElement(document, '.delivery-note'),
				productJSON.locale,
				typeof shipmentTimeInfoDef !== 'undefined',
				typeof shipmentTimeInfoExp !== 'undefined'
			),
			flyout: new Flyout({
				el: scope,
				control: '.option',
				eventOn: 'mouseenter',
				eventOff: 'mouseleave',
				actionElement: '.custom-select-holder',
				flyoutElement: '.flyout',
				data: productJSON,
			}),
			hotfoilBuilder,
			hotfoilEffects: {
				mobile: mobileImages,
				desktop: desktopImages,
			},
		},
		forbidPageScroll: true,
	});

	if (jQuery('#localization-modal').length) {
		const localizationPopup = new Popup({
			popup: '#localization-modal',
			closeBtn: '.modal-window .close-btn, .modal-window .stay-on-page',
		}).init();

		localizationPopup.attachCloseEvent();
	}

	if (hasTestProductOnPage) {
		new TestProductPopup({ trackingCategory: TrackingData.PAGE_PDP });
	}

	new OpenClose({
		toggler: '.js-more-details',
		classOpen: 'is-open',
	});

	if (document.getElementsByClassName('is-google-shopping')) {
		new OpenClose({
			parent: '#main',
			toggler: '.js-google-shopping-more-details',
			content: '.js-google-shopping-hidden-content',
			classOpen: 'is-open',
		});
	}

	new CustomSelect({
		el: '.custom-select',
		forbidPageScroll: true,
		product: productJSON,
		trackingCategory: TrackingData.PAGE_PDP,
	});

	const moreDetailsPopup = new MoreDetailsPopup({ trackingCategory: TrackingData.PAGE_PDP });

	moreDetailsPopup.subscribe('popup:opened', () => {
		const els = jQuery('.modal-design-success-popup .js-personalize-button');

		confiButton.addButton(els);
	});

	new HeaderFeatures({
		trackingCategory: TrackingData.PAGE_PDP,
	});

	const header = document.getElementById('header');

	if (header) {
		new UpdateUserAccount(header, PageTypes.PDP);
	}

	// Check if the parameter r is present in the url and it is equal to 'pla' (Requirements KUN-887)
	if (getUrlParams().r && getUrlParams().r === 'pla' && productJSON.primaryCategory.identifier) {
		new TeaserTiles({
			data: {
				category: productJSON.primaryCategory.identifier,
				excludedSku: productJSON.abstractSku,
				teaserVariant: getUrlParams().va || '0',
			},
			trackingCategory: TrackingData.PAGE_PDP,
		});

		const isMobile = new DeviceManager().isMobileDevice();

		if (isMobile) {
			const goToPDPButton = document.querySelector('.js-go-to-pdp');
			const pdpUrl = location.href.replace('?r=pla&', '?').replace('?r=pla', '').replace('&r=pla', '');

			goToPDPButton.setAttribute('href', pdpUrl);
		}
	}

	_.each(
		jQuery('.slider-holder'),
		(item) =>
			new Gallery({
				holder: item,
				trackingCategory: TrackingData.PAGE_PDP,
			})
	);

	const productImagesSlider = new ProductImagesSlider({
		el: document.querySelector('.js-gallery-slider-holder'),
		parentElement: document.querySelector('.js-main-image'),
	});

	const innerPages = urlParams.innerPages || productJSON.preConfig.innerPages;

	if (innerPages) {
		// This guarantees on load that we only see the innerPages images for the currently selected format.
		productImagesSlider.onInnerPagesOptionChange(format, innerPages);
	}

	const zoomGalleryPopup = new ZoomGalleryPopup({
		productImagesSlider,
		trackingCategory: TrackingData.PAGE_PDP,
	});

	hotfoilBuilder.setOnPopupEvents(zoomGalleryPopup, '.js-zoom-gallery-image');

	jQuery('.js-video-teaser').each(function () {
		new VideoEmbed({ el: this });
	});

	new BuySamplePopup({
		priceCalculator,
	});

	new BannerController({
		trackingCategory: TrackingData.PAGE_PDP,
	});

	new GA4SocialNetworkTracker();

	new ShareLinks();

	const trackingItem = jQuery('.tracking-item');

	if (trackingItem.length) {
		trackingItem.on('click', function (response) {
			response.preventDefault();

			const link = this.href;

			Tracker.trackAndNavigate(
				{
					category: TrackingData.PAGE_PDP,
					action: this.getAttribute('data-tracking-action'),
					label: link,
				},
				link
			);
		});
	}

	EnhanceEcommerce.trackProductDetailView(productJSON);

	options.subscribe('options:format:changed', (event, format) => {
		Tracker.trackShoppingSKU(getShoppingSku());
		productImagesSlider.onFormatChange(format);
	});

	options.subscribe('options:color:changed', () => {
		Tracker.trackShoppingSKU(getShoppingSku());
	});

	options.subscribe('options:format-color:changed', (event, data) => {
		productImagesSlider.updateOverlayImagesOnFormatColorChange(data.format, data.color, productJSON);
	});

	options.subscribe('options:format-innerPages:changed', (event, data) => {
		productImagesSlider.onInnerPagesOptionChange(data.format, data.innerPages, { setActive: true });
	});

	options.subscribe('options:changed', (event, data) => {
		Tracker.trackMasterFeedId(productJSON);
		if (hasCover(hardcoverProducts, softcoverProducts)) {
			switchCover(data.cover);
		}
	});

	instantiateScrollers();
};

new PDP();
